// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectReplaceAlertMessage } from "../../../../Utils/DirectMessages/DirectReplaceAlertMessage.js"
export let ReplaceAlertMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

ReplaceAlertMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

ReplaceAlertMessageProcessor.prototype.decode = function (fs)
{
    let msg = new DirectReplaceAlertMessage()
    let ff = FieldsFactory

    msg.AlertId = fs.GetValue(ff.FIELD_ALERT_ID)
    msg.InstrumentTradableID = fs.GetValue(ff.FIELD_TRADABLE_INSTRUMENT_ID)
    msg.RouteId = fs.GetValue(ff.FIELD_ROUTE_ID)
    msg.AlertType = fs.GetValue(ff.FIELD_ALERT_TYPE)
    msg.AlertCondition = fs.GetValue(ff.FIELD_ALERT_CONDITION)
    msg.AlertValue = fs.GetValue(ff.FIELD_ALERT_VALUE)
    msg.AlertImportance = fs.GetValue(ff.FIELD_ALERT_IMPORTANCE)
    msg.Date = fs.GetValue(ff.FIELD_DATE)
    msg.AlertAfterExecute = fs.GetValue(ff.FIELD_ALERT_AFTER_EXECUTE)
    msg.AlertAction = fs.GetValue(ff.FIELD_ALERT_ACTION)
    msg.AlertNotification = fs.GetValue(ff.FIELD_ALERT_NOTIFICATION)
    msg.Text = fs.GetValue(ff.FIELD_TEXT)

    return [msg]
}